import { render, staticRenderFns } from "./MenusAdmin.vue?vue&type=template&id=226032bc"
import script from "./MenusAdmin.vue?vue&type=script&lang=js"
export * from "./MenusAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports